import { gql } from '@apollo/client';

export const QUERY_GENDER = gql`
  query gender {
    __typename
    genderAppearances {
      __typename
      id
      code
      name
      enabled
      sortOrder
    }
    genderIdentities {
      __typename
      id
      code
      name
      enabled
      sortOrder
    }
  }
`;
